import React from "react";
import PropTypes from "prop-types";
import { Isvg, Spinner } from "../../../components";
import Instructions from "./success/instructions";

export default class AssignmentSuccess extends React.Component {
  constructor(props) {
    super(props);
    var userData = Fraction.Helpers.userData();
    this.renderActions = this.renderActions.bind(this);
  }

  componentDidMount() {
    let route = window.location.hash.split("cfi")[0];
    if (route.slice(0, 2) === "#/") {
      route = route.slice(2);
    }
    Fraction.Router.setRoute(route, true);
    if (!this.props.saving && !this.props.assignment.uuid) {
      this.props.back(true);
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.props.saving && prevProps.saving) {
      this.mountFocus.focus();
    }
  }

  renderActions(url, vbid, uuid) {
    if (this.props.returnUrl) {
      return (
        <a
          className="done vst-button"
          href={Fraction.Helpers.Locations.addParameter(
            this.props.returnUrl,
            "assignment_id",
            uuid
          )}
        >
          {i18n.t("base.done")}
        </a>
      );
    } else {
      return <Instructions url={url} vbid={vbid} uuid={uuid} />;
    }
  }

  render() {
    const { vbid, uuid } = this.props.assignment;
    const url = `${window.location.origin}/#/books/${vbid}/assignment/${uuid}`;
    if (!this.props.saving) {
      return (
        <div id="assignment-success">
          <Isvg src="/img/assignments/assets/img/assignment_creation_complete.svg" />
          <h2
            ref={header => {
              this.mountFocus = header;
            }}
            tabIndex={-1}
            className="success-title"
          >
            {i18n.t("assignments.success", {
              title: this.props.assignment.title
            })}
          </h2>
          {this.renderActions(url, vbid, uuid)}
        </div>
      );
    }
    return <Spinner />;
  }
}

AssignmentSuccess.propTypes = {
  saving: PropTypes.bool.isRequired,
  assignment: PropTypes.object.isRequired
};

AssignmentSuccess.defaultProps = {
  saving: false
};
